export default __webpack_public_path__ + "static/media/Nimbus Logo.add5dcb9.png";